import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import global from './config/global';
import translationGr from './locales/gr/translation';
import translationIT from './locales/it/translation';
import translationRS from './locales/rs/translation';
import translationSP from './locales/sp/translation';
import translationENG from './locales/en/translation';
import translationSR from './locales/sr/translation';
//translations
var resources = {
    gr: {
        translation: translationGr
    },
    it: {
        translation: translationIT
    },
    rs: {
        translation: translationRS
    },
    sp: {
        translation: translationSP
    },
    en: {
        translation: translationENG
    },
    sr: {
        translation: translationSR
    }
};
i18n.use(detector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
    resources: resources,
    lng: global.CULTURE_LANG,
    fallbackLng: 'en',
    keySeparator: false,
    interpolation: {
        escapeValue: false // react already safes from xss
    }
});
export default i18n;
